import { UserPermissionAction } from "avvir";

import useAvvirSelector from "../../services/component_helpers/component_effects/use_avvir_selector";
import { usePermissionService } from "./use_permission_service";
import getOrganizationId from "../../services/getters/organization_getters/get_organization_id";

export function useIsManageUsersAccessible(): boolean {
  const organizationId = useAvvirSelector(getOrganizationId);
  const permissionService = usePermissionService();
  if (organizationId == null) {
    return false;
  }

  return permissionService.areAnyPermittedForCurrentOrganization([
    UserPermissionAction.GRANT_ROLE_BASIC_USER,
    UserPermissionAction.GRANT_ROLE_EDITOR,
    UserPermissionAction.GRANT_ROLE_ADMIN,
    UserPermissionAction.GRANT_ROLE_QA_QC_USER,
    UserPermissionAction.GRANT_ROLE_SUPERADMIN,
  ], false, true);
}
